export default __webpack_public_path__ + "static/media/grafema_SET_13.ee9877eb.jpg";